import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityInfo = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'Bank-Level Encryption',
      description: 'All documents are encrypted using AES-256 encryption during transmission and storage'
    },
    {
      icon: 'Lock',
      title: 'Secure Storage',
      description: 'Documents are stored in SOC 2 compliant data centers with multi-layer security'
    },
    {
      icon: 'Eye',
      title: 'Privacy Protected',
      description: 'Your documents are only accessed by authorized compliance officers'
    },
    {
      icon: 'Trash2',
      title: 'Auto Deletion',
      description: 'Documents are automatically deleted after regulatory retention period'
    }
  ];

  const certifications = [
    { name: 'PCI DSS', description: 'Payment Card Industry Compliant' },
    { name: 'SOC 2', description: 'Security & Availability Certified' },
    { name: 'GDPR', description: 'General Data Protection Regulation' },
    { name: 'ISO 27001', description: 'Information Security Management' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="ShieldCheck" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-foreground">Security & Privacy</h2>
          <p className="text-sm text-muted-foreground">Your documents are protected with enterprise-grade security</p>
        </div>
      </div>
      <div className="space-y-4 mb-6">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name={feature?.icon} size={16} className="text-success" />
            </div>
            <div>
              <h3 className="text-sm font-medium text-foreground">{feature?.title}</h3>
              <p className="text-xs text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="border-t border-border pt-6">
        <h3 className="text-sm font-medium text-foreground mb-4">Compliance Certifications</h3>
        <div className="grid grid-cols-2 gap-3">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-center space-x-2 p-2 bg-muted rounded-lg">
              <Icon name="Award" size={14} className="text-primary flex-shrink-0" />
              <div className="min-w-0">
                <p className="text-xs font-medium text-foreground">{cert?.name}</p>
                <p className="text-xs text-muted-foreground truncate">{cert?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-primary">Why do we need these documents?</h4>
            <p className="text-xs text-primary/80 mt-1">
              We're required by financial regulations to verify your identity to prevent fraud and comply with anti-money laundering laws. This protects both you and our platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityInfo;